import request from '@/utils/request';
import wc from '@/utils/wc';
import {offset} from "bootstrap-vue/es/utils/dom";

export function fetchProductsById(id) {
  return new Promise((resolve, reject) => {
    wc.getAsync(`products?include=${id}&per_page=100`).then(function(result) {
      resolve(JSON.parse(result.toJSON().body));
    }).catch((err) => {
      reject(err);
    })
  });
}

export function fetchProductsByName(name) {
  return new Promise((resolve, reject) => {
    wc.getAsync(`products?search=${name}`).then(function(result) {
      resolve(JSON.parse(result.toJSON().body));
    }).catch((err) => {
      reject(err);
    })
  });
}

export function fetchProductBySlug(name) {
  return new Promise((resolve, reject) => {
    wc.getAsync(`products?slug=${name}`).then(function(result) {
      resolve(JSON.parse(result.toJSON().body)[0]);
    }).catch((err) => {
      reject(err);
    })
  });
}

export function fetchProductsWithCategory(id) {
  return new Promise((resolve, reject) => {
    wc.getAsync(`products?per_page=100&category=${id}`).then(function(result) {
      resolve(JSON.parse(result.toJSON().body));
    }).catch((err) => {
      reject(err);
    })
  });
}

export function fetchProductsWithTag(id) {
  return new Promise((resolve, reject) => {
    wc.getAsync(`products?per_page=100&tag=${id}`).then(function(result) {
      resolve(JSON.parse(result.toJSON().body));
    }).catch((err) => {
      reject(err);
    })
  });
}

export function fetchProductsWithCategoryAndTag(cId, tId) {
  return new Promise((resolve, reject) => {
    wc.getAsync(`products?per_page=100&category=${cId}&tag=${tId}`).then(function(result) {
      resolve(JSON.parse(result.toJSON().body));
    }).catch((err) => {
      reject(err);
    })
  });
}

async function _fetchProductsWithCategoryAndName(cId, name, offset = 0) {
  const result = await wc.getAsync(`products?per_page=10&category=${cId}&search=${name}&offset=${offset}`)
  return JSON.parse(result.toJSON().body)
}

export function fetchProductsWithCategoryAndName(cId, name) {
  return new Promise(async (resolve, reject) => {
    const products = []
    let iteration = 0
    let continueLooping = true
    while (continueLooping) {
      const newProducts = await _fetchProductsWithCategoryAndName(cId, name, (iteration*10) )
      if (newProducts) {
        for (let i = 0; i < newProducts.length; i++) {
          products.push(newProducts[i])
        }
        if (newProducts.length === 0) {
          continueLooping = false
        }
        iteration++
      } else {
        continueLooping = false
      }
    }

    resolve(products)
  });
}

export function fetchProductVariations(id) {
  return new Promise((resolve, reject) => {
    wc.getAsync(`products/${id}/variations`)
      .then(function(result) {
        resolve(JSON.parse(result.toJSON().body));
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function fetchProductVariation(pId, vId) {
  return new Promise((resolve, reject) => {
    wc.getAsync(`products/${pId}/variations/${vId}`)
      .then(function(result) {
        resolve(JSON.parse(result.toJSON().body));
      })
      .catch(err => {
        reject(err);
      });
  });
}
